import ACTIONS from "../actions/ServicesActions";
import _ from "lodash";
import {populateFilterOptions} from "../../../common/utils/PopulateFilterOptions";
import {filterServices, listPageGlobalFilter} from "../../../common/utils/FilterFunctions";
import {setFilters} from "../../../common/utils/SetFilters";
import {SortFields} from "../constants/ServiceActionConstants";
import SortDirection from "../../../common/constants/SortDirection";

const initialState = {
    all_services: [],
    all_countries: [],
    kyc_services: [],
    kycSortKey: SortFields.SERVICE_NAME,
    kycSortDirection: SortDirection.ASC,
    filtered_kyc_services: [],
    filterOptions: {
        dpFilterOptions: [],
        countryOptions: [],
        statusOptions: [],
        subDPTypeOptions: [],
        verifiableElementsOptions: [],
        invoiceNameOptions: [],
    },
    filters: {
        providerNameFilter: null,
        countryFilter: [],
        statusFilter: null,
        subDPTypeFilter: null,
        verifiableElementsFilter: null,
        invoiceNameFilter: null,
    },
    type: "",
    kyc_filtered_state: true,
    all_kyc_selected: false,
    some_kyc_selected: false,
    selected_kyc_services: [],
    all_billing_groups: [],
    all_service_config_names: [],
    all_service_sets: [],
};

/**
 * Reducer to manage state relevant to the services collection.
 * */

const servicesReducer = (state = initialState, action) => {
    switch (action.type) {

        case ACTIONS.Types.KYC_GLOBAL_SEARCH: {
            let newState = _.cloneDeep(state);
            newState.filtered_kyc_services = listPageGlobalFilter(action.payload, newState.kyc_services);

            return newState;
        }

        case ACTIONS.Types.TOGGLE_KYC_SORT: {
            let newState = _.cloneDeep(state);
            newState.kycSortKey = action.payload
            newState.kycSortDirection = newState.kycSortDirection === SortDirection.ASC
                ? SortDirection.DESC : SortDirection.ASC;
            if (newState.kycSortDirection === SortDirection.ASC) {
                newState.filtered_kyc_services = _.sortBy(newState.filtered_kyc_services,
                    [s => s[action.payload].toString().toLowerCase()], [action.payload]);
            } else {
                newState.filtered_kyc_services = _.sortBy(newState.filtered_kyc_services,
                    [s => s[action.payload].toString().toLowerCase()], [action.payload]).reverse();
            }
            return newState;
        }

        case ACTIONS.Types.ALL_KYC_SELECTED: {
            let newState = _.cloneDeep(state);
            newState.all_kyc_selected = !newState.all_kyc_selected;
            const selectedIds = action.payload.serviceIds;
            newState.selected_kyc_services = action.payload.isSelected
                ? [...new Set([...selectedIds])]
                : newState.selected_kyc_services.filter(selectedServiceId =>
                    !newState.selected_kyc_services.includes(selectedServiceId));
            return newState
        }

        case ACTIONS.Types.SOME_KYC_SELECTED: {
            let newState = _.cloneDeep(state);
            const selectedId = [action.payload.serviceId];
            newState.selected_kyc_services = action.payload.isSelected
                ? [...new Set([...newState.selected_kyc_services, ...selectedId])]
                : newState.selected_kyc_services.filter(selectedServiceId =>
                    !selectedId.includes(selectedServiceId));
            newState.some_kyc_selected = newState.selected_kyc_services.length > 0 && !newState.all_kyc_selected
            return newState;
        }

        case ACTIONS.Types.LOAD_ALL_SERVICES: {
            let newState = _.cloneDeep(state);
            newState.all_services = action.payload;
            return newState;
        }

        case ACTIONS.Types.LOAD_KYC_SERVICES: {
            let newState = _.cloneDeep(state);
            newState.kyc_services = action.payload;
            newState.filtered_kyc_services = newState.kyc_services;
            // split the string of country codes to an array
            newState.filtered_kyc_services.forEach(service => {
                if (service.associated_countries !== null) {
                    service.associated_countries = service.associated_countries.split(",");
                }
                if (service.verifiable_elements !== null) {
                    service.verifiable_elements = service.verifiable_elements.split(",");
                }
            })
            newState.filterOptions = populateFilterOptions(newState.filterOptions, newState.kyc_services)
            newState.kyc_filtered_state = false;
            return newState;
        }

        case ACTIONS.Types.SET_KYC_FILTER: {
            let newState = _.cloneDeep(state);
            newState.filters = setFilters(newState.filters,
                action.payload.filterType, action.payload.filterOption);
            return newState;
        }

        case ACTIONS.Types.FILTER_KYC_SERVICES: {
            let newState = _.cloneDeep(state);
            newState.filtered_kyc_services = filterServices(newState.filters, newState.kyc_services);
            newState.kyc_filtered_state = true;
            return newState;
        }

        case "SETTING_SUPPORTING_SELECTIONS": {
            let newState = _.cloneDeep(state);
            newState.all_billing_groups = action.payload.billing_groups;
            newState.all_service_config_names = action.payload.all_service_config_names;
            newState.all_service_sets = action.payload.all_service_sets;
            return newState;
        }

        default:
            return state;
    }
};

export default servicesReducer;
